import { TasksView } from '../components/tasks/TasksView';

/**
 * Global Tasks page. The whole Linear-style experience now lives in the shared
 * <TasksView /> (CLE-197) so the global page and a project's Tasks tab render
 * the exact same UI. Here it runs unscoped (cross-project).
 */
export function TasksPage() {
  return (
    <div className="w-full p-4 sm:p-6 lg:p-8">
      <TasksView />
    </div>
  );
}
